import {
  BrowserRouter,
  Navigate,
  Route,
  Routes
} from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import {
  About,
  Story,
  ThreadStory
} from './components/EditorialSections';
import Collection from './components/Collection';
import Experience from './components/Experience';
import Ordering from './components/Ordering';
import Contact from './components/Contact';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';
import ScrollToTop from './components/ScrollToTop';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import OrderTrackingPage from './pages/OrderTrackingPage';
import LiveOrderPage from './pages/LiveOrderPage';
import ProductPage from './pages/ProductPage';
import ShopPage from './pages/ShopPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import { CartProvider } from './commerce/CartContext';
import { LandingImageProvider } from './landing/LandingImageContext';
import './App.css';
import './commerce.css';
import './checkout.css';
import './admin.css';
import './admin-modern.css';
import './product-gallery.css';
import './live-tracking.css';
import './admin/admin-redesign.css';
import './admin/admin-order-tools.css';
import './zevi-new-features.css';

function HomePage() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Story />
        <Collection />
        <ThreadStory />
        <Experience />
        <Ordering />
        <About />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

function StorePage({ children }) {
  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  );
}

function Storefront() {
  return (
    <LandingImageProvider>
      <CartProvider>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route
            path="/shop"
            element={<StorePage><ShopPage /></StorePage>}
          />
          <Route
            path="/product/:slug"
            element={<StorePage><ProductPage /></StorePage>}
          />
          <Route
            path="/cart"
            element={<StorePage><CartPage /></StorePage>}
          />
          <Route
            path="/checkout"
            element={<StorePage><CheckoutPage /></StorePage>}
          />
          <Route
            path="/order-tracking"
            element={<StorePage><OrderTrackingPage /></StorePage>}
          />
          <Route
            path="/track/:token"
            element={<StorePage><LiveOrderPage /></StorePage>}
          />
          <Route path="/admin" element={<AdminDashboardPage />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/adimin" element={<AdminDashboardPage />} />
          <Route path="/adimin/login" element={<AdminLoginPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <CartDrawer />
      </CartProvider>
    </LandingImageProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Storefront />
    </BrowserRouter>
  );
}

export default App;